import React, { useRef } from 'react';
import PropTypes from 'prop-types';

const ReceiptModal = ({ show, onClose, orderData, storeInfo }) => {
    const printRef = useRef();

    if (!orderData) return null;

    const {
        invoice_no,
        status,
        sale_date,
        total_amount,
        discount,
        paid_amount,
        due_amount,
        payment_status,
        payment_method,
        items,
        id,
    } = orderData;

    const handlePrint = () => {
        const content = printRef.current;
        const printWindow = window.open('', '_blank');
        if (printWindow && content) {
            printWindow.document.write(`
        <html>
          <head>
            <title>Receipt</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 10px; }
              table { width: 100%; border-collapse: collapse; margin-top: 10px; }
              th, td { padding: 5px; text-align: left; }
              .text-end { text-align: right; }
              .fw-bold { font-weight: bold; }
              .text-center { text-align: center; }
              .border-bottom { border-bottom: 1px dashed #ccc; margin-bottom: 10px; }
            </style>
          </head>
          <body>${content.innerHTML}</body>
        </html>
      `);
            printWindow.document.close();
            printWindow.focus();
            printWindow.print();
        }
    };

    return (
        <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content p-2">
                    <div className="modal-body" ref={printRef}>
                        {/* Header */}
                        <div className="icon-head text-center">
                            <img src="/assets/img/logo.png" width="100" height="30" alt="Receipt Logo" />
                        </div>

                        {/* Business Info */}
                        <div className="text-center info">
                            <h6>{storeInfo?.name || 'Your Store Name'}</h6>
                            <p className="mb-0">Phone Number: {storeInfo?.phone || '+1 5656665656'}</p>
                        </div>

                        {/* Invoice Info */}
                        <div className="tax-invoice mt-2">
                            <h6 className="text-center">Tax Invoice</h6>
                            <div className="row">
                                <div className="col-sm-12 col-md-6">
                                    <div><span>Invoice No: </span>{invoice_no}</div>
                                    <div><span>Status: </span>{status}</div>
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <div><span>Date: </span>{sale_date}</div>
                                    <div><span>Payment Method: </span>{payment_method}</div>
                                </div>
                            </div>
                        </div>

                        {/* Items Table */}
                        <table className="table-borderless w-100 table-fit mt-3">
                            <thead>
                                <tr>
                                    <th># Item</th>
                                    <th>Price</th>
                                    <th>Qty</th>
                                    <th className="text-end">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items?.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            {index + 1}. {item.product_name}
                                            {item.variant && (
                                                <> ({item.variant.variant_name}: {item.variant.variant_value})</>
                                            )}
                                        </td>
                                        <td>${parseFloat(item.price).toFixed(2)}</td>
                                        <td>{item.quantity}</td>
                                        <td className="text-end">
                                            ${parseFloat(item.subtotal).toFixed(2)}
                                        </td>
                                    </tr>
                                ))}

                                {/* Totals */}
                                <tr>
                                    <td colSpan="4">
                                        <table className="table-borderless w-100 table-fit mt-2">
                                            <tbody>
                                                <tr>
                                                    <td className="fw-bold">Sub Total :</td>
                                                    <td className="text-end">
                                                        ${items.reduce((sum, i) => sum + parseFloat(i.subtotal), 0).toFixed(2)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Discount :</td>
                                                    <td className="text-end">-${discount.toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Total Bill :</td>
                                                    <td className="text-end">${total_amount.toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Paid :</td>
                                                    <td className="text-end">${paid_amount.toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Due :</td>
                                                    <td className="text-end">${due_amount.toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Status :</td>
                                                    <td className="text-end text-capitalize">{payment_status}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Footer */}
                        <div className="text-center invoice-bar mt-3">
                            <div className="border-bottom border-dashed mb-2">
                                <p>**VAT against this challan is payable through central registration. Thank you for your business!</p>
                            </div>
                            <p className="text-dark fw-bold mt-1">Sale #{id}</p>
                            <p>Thank You For Shopping With Us. Please Come Again</p>

                        </div>
                    </div>
                    <div className="d-flex justify-content-center gap-2 mt-2 no-print">
                        <button onClick={handlePrint} className="btn btn-sm btn-primary">Print</button>
                        <button onClick={onClose} className="btn btn-sm btn-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

ReceiptModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    orderData: PropTypes.object,
    storeInfo: PropTypes.object,
};

export default ReceiptModal;
